import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.js";

const useStyles = makeStyles(descriptionStyle);

export default function SectionDescription() {
  const classes = useStyles();
  return (
    <div className={classNames(classes.aboutDescription, classes.textCenter)}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <Box m={3}>
            <h5 className={classes.description}>
              Distribuidor Independente Prouvé. Comercializa produtos únicos com
              base em fórmulas próprias, que se distinguem pelos seus aromas
              incríveis de óleos criados na cidade francesa de Grasse – a
              capital da perfumaria mundial.
            </h5>
          </Box>
        </GridItem>
      </GridContainer>
    </div>
  );
}
